@if (showError()) {
  <div class="error" [class.rounded]="rounded">
    <span>{{ getError() }}</span>
  </div>
}
